import { render, staticRenderFns } from "./yuerbfengren.vue?vue&type=template&id=1efa5698&scoped=true&"
import script from "./yuerbfengren.vue?vue&type=script&lang=js&"
export * from "./yuerbfengren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efa5698",
  null
  
)

export default component.exports